'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var brand = require('../types/brand.js');
require('../types/cms/enums.js');

const BASE_STYLESHEET_URL = 'https://fonts.googleapis.com/css?family=';
const DATA_ATTRIBUTE = 'data-brand-engine-google-font';
const createStylesheetAndAppendToDom = (fontIdentifier) => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', `${BASE_STYLESHEET_URL}${fontIdentifier}`);
    link.setAttribute(DATA_ATTRIBUTE, '');
    document.body.appendChild(link);
};
const getFontIdentifier = (googleFont) => {
    const family = googleFont.name.replace(/\s/g, '+');
    return `${family}:${googleFont.variants
        .reduce((acc, cur) => {
        acc.push(cur.name);
        return acc;
    }, [])
        .join('|')}`;
};
/**
 * Take a list of brand fonts, and if the consumer determines the feature is
 * enabled, filters for Google fonts, and appends its stylesheet to the document.
 *
 * Usage is only intended for consumers that are purely client side applications.
 * If your consumer utilizes server side rendering, it is recommended to simply
 * append the stylesheets to the documents head.
 *
 * @param isFeatureEnabled
 * @param brandFonts
 */
const useClientGoogleFonts = ({ isFeatureEnabled, brandFonts = [] }) => {
    const [processedFontIdentifiers, setProcessedFontIdentifiers] = react.useState([]);
    const googleFonts = react.useMemo(() => brandFonts.filter(brandFont => brandFont.fontType === brand.BrandFontType.Google), [brandFonts]);
    const removeStylesheets = () => {
        const stylesheets = document.querySelectorAll(`[${DATA_ATTRIBUTE}]`);
        // querySelectorAll returns a NodeList and this is the safest way to iterate through it
        for (let i = 0; i < stylesheets.length; i++) {
            document.body.removeChild(stylesheets[i]);
        }
    };
    react.useEffect(() => {
        return removeStylesheets;
    }, []);
    react.useEffect(() => {
        if (!isFeatureEnabled) {
            return;
        }
        if (!googleFonts.length) {
            return;
        }
        for (const googleFont of googleFonts) {
            const fontIdentifier = getFontIdentifier(googleFont);
            if (processedFontIdentifiers.includes(fontIdentifier)) {
                continue;
            }
            createStylesheetAndAppendToDom(fontIdentifier);
            setProcessedFontIdentifiers(prevState => [...prevState, fontIdentifier]);
        }
    }, [isFeatureEnabled, googleFonts]);
};

exports.useClientGoogleFonts = useClientGoogleFonts;
//# sourceMappingURL=useClientGoogleFonts.js.map
